<template>
		<div class="content home-page">
		<Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
        <div>{{$t('Back')}}</div>
      </div>
    </div>
			<div class="information2">
				<div class="faq-content" v-if="list!=''">
					<div class="">
						<p class="fs50 ac"><span>{{$t('Guidance')}}</span></p>
						<p class="mt30" v-html="list"></p>
					</div>
				</div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
export default {
    components:{
		Header
    },
    data() {
        return {
			list:[]

		}
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
      let data = {
        type:'3'
      }
			that.$api.post('/api/index/help',data,r =>{
				that.$parent.returnCode(r,function(){
          if(localStorage.getItem('lang')=='en'){
            that.list = r.data.content
          }else if(localStorage.getItem('lang')=='bur'){
            that.list = r.data.mm_content
          }else{
            that.list = r.data.wz_content
          }
					that.$parent.loadModal(false);
				});

			})

		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/guidance.vue